












import { Component, Mixins } from "vue-property-decorator";
import { GraphKinds } from "../../../../../../documaker/domain/format/objects";
import { RectangleCoordinatableObjectDrawerBase } from "./base";
import { ObjectKeys } from "../../../../../domain/configuration";
import { default as NamedRectangleCoordinatableObjectDrawer } from "./NamedRectangleCoordinatableObjectDrawer.vue";

@Component({
  components: {
    NamedRectangleCoordinatableObjectDrawer,
  },
})
export default class GraphObjectDrawer extends Mixins(RectangleCoordinatableObjectDrawerBase) {
  get kind(): GraphKinds {
    return this.readPropertyOrDefault(s => s.kind().getValue(), GraphKinds.RangeOfMotion);
  }

  get displayName(): string {
    switch (this.kind) {
      case GraphKinds.RangeOfMotion:
        return this.name;
      case GraphKinds.Line:
        return this.name;
      default:
        return "";
    }
  }

  get configurationKey(): ObjectKeys {
    switch (this.kind) {
      case GraphKinds.RangeOfMotion:
        return "RangeOfMotionGraph";
      case GraphKinds.Line:
        return "Graph";
      default:
        return "NotImplemented";
    }
  }
}
